import React, { useEffect, useContext, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useNavigate, useLocation } from 'react-router-dom';
import { isTablet, isMobileOnly, isDesktop } from 'react-device-detect';
import {
  Box,
  Container,
  Hidden,
  Button,
} from '@material-ui/core';

import Moment from 'moment'
Moment.locale('fr')

import cropRotateIcon from "../images/cropRotateIcon.svg"

import UserContext from "../contexts/UserContext"
import LanguageContext from "../contexts/LanguageContext"

import { GLB_URL_APIS } from "../utils/APIS"

import PlanCours from "../components/ui/Formation/PlanCours"
import MyMiniModal from "../components/ui/MyMiniModal"

import FormatTitre from "../components/ui/Formats/FormatTitre"
import FormatVideo from "../components/ui/Formats/FormatVideo"
import FormatTexte from "../components/ui/Formats/FormatTexte"
import FormatQuestionnaireV2 from "../components/ui/Formats/FormatQuestionnaireV2"
import FormatQuizz from "../components/ui/Formats/FormatQuizz"
import FormatDiag from "../components/ui/Formats/FormatDiag"
import FormatInputTexte from "../components/ui/Formats/FormatInputTexte"
import FinDeFormation from "../components/ui/Formats/FinDeFormation"

import IcebreakerQuestions from "../components/ui/Formats/IcebreakerQuestions"

export const FormatSwitch = (props) => {

  //console.log(props)

  if (props?.format) {
    switch (props?.format?.type) {
      case 'Titre':
        return <FormatTitre {...props} />
      case 'Video':
        return <FormatVideo {...props} />
      case 'Texte':
        return <FormatTexte {...props} />
      case 'QuestionnaireV2':
        return <FormatQuestionnaireV2 {...props} />
      case 'Quizz':
        return <FormatQuizz {...props} />
      case 'Diagnostic':
        return <FormatDiag {...props} />
      case 'InputTexte':
        return <FormatInputTexte {...props} />
      default:
        return (<></>)
    }
  } else {
    if (props?.actFormation?.isDone && props?.actIndex?.chapitre === "max") {
      return <FinDeFormation {...props} />
    } else if (props?.isEditor && props?.actIndex?.chapitre === "max") {
      return <FinDeFormation {...props} />
    } else {
      return (<></>)
    }
  }
}


const Formation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { actLanguage, languageValues } = useContext(LanguageContext)
  const {
    currentUser,
    actPlan,
    actFormation,
    actIndex,
    lastDoneIndex,
  } = useContext(UserContext)

  const [haveToViewIcebreakerQuestions, setHaveToViewIcebreakerQuestions] = useState(null)

  useEffect(() => {
    if (actFormation && currentUser) {
      if (location?.pathname === "/icebreaker" && actFormation?.userResult === null && currentUser?.icebreakerQuestions !== null) {
        if (currentUser?.icebreakerQuestions?.annees === true || currentUser?.icebreakerQuestions?.secteurs === true || currentUser?.icebreakerQuestions?.diplome === true) {
          setHaveToViewIcebreakerQuestions(true)
        } else {
          setHaveToViewIcebreakerQuestions(false)
        }
      } else {
        setHaveToViewIcebreakerQuestions(false)
      }
    }
  }, [actFormation, currentUser, location])

  useEffect(() => {
    if (actFormation && !actFormation?.isOpen) {
      navigate('/dashboard')
    }
  }, [actFormation])

  /* ORIENTATION MODAL */
  const [previousOrientation, setPreviousOrientation] = useState(null)
  const [modalMustPortrait, setModalMustPortrait] = useState(false)
  const [modalMustLandscape, setModalMustLandscape] = useState(false)
  useEffect(() => {
    const handleResize = () => {
      let orientation = null;
      if (window.innerWidth >= window.innerHeight) {
        orientation = "landscape"
      } else {
        orientation = "portrait"
      }
      if (previousOrientation !== orientation) {
        setPreviousOrientation(orientation)
        let viewModalMustPortrait = false
        let viewModalMustLandscape = false
        if (isMobileOnly && orientation === "landscape") {
          viewModalMustPortrait = true
        } else if (isTablet && orientation === "portrait") {
          viewModalMustLandscape = true
        } else if (isDesktop && orientation === "portrait") {
          viewModalMustLandscape = true
        }
        setModalMustPortrait(viewModalMustPortrait)
        setModalMustLandscape(viewModalMustLandscape)
      }
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [previousOrientation])
  /* END ORIENTATION MODAL */


  /* PLAN DE COURS */
  const [viewPlanCours, setViewPlanCours] = useState(false)
  /* END PLAN DE COURS */

  return (
    <>
      <Helmet>
        <title>{languageValues?.formation?.pageTitle[actLanguage] || ''} | TheLab</title>
      </Helmet>
      {viewPlanCours &&
        <PlanCours
          actFormation={actFormation}
          lastDoneIndex={lastDoneIndex}
          setViewPlanCours={setViewPlanCours}
          viewPlanCours={viewPlanCours}
          actPlan={actPlan}
        />
      }
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box sx={{
          position: "fixed",
          width: "1028px",
          height: "537px",
          left: "calc(50% - 1028px/2)",
          top: "0px",
          backgroundImage: "url('./static/MainLayout-bg.svg')",
          zIndex:0,
        }} />
        <Box sx={{
          position: "fixed",
          width: "1100px",
          height: "600px",
          left: "calc(50% - 1100px/2)",
          top: "0px",
          background: "radial-gradient(72.67% 72.67% at 50% 8.92%, rgba(255, 255, 255, 0) 0%, #FAF8F6 100%)",
          zIndex:1,
        }} />
        <Box
          sx={{
            flex:1,
            padding:0,
            backgroundColor:"transparent",
            zIndex:3,
          }}
        >
          {haveToViewIcebreakerQuestions === true &&
            <IcebreakerQuestions
              actFormation={actFormation}
            />
          }

          {haveToViewIcebreakerQuestions === false &&
            <FormatSwitch
              actFormation={actFormation}
              format={actFormation?.chapitre[actIndex?.chapitre]?.partie[actIndex?.partie]?.sequence[actIndex?.sequence]}
              actIndex={actIndex}
              setViewPlanCours={setViewPlanCours}
              viewPlanCours={viewPlanCours}
              actPlan={actPlan}
            />
          }


        </Box>
      </Box>

      {/* MODAL MUST PORTRAIT */ }
      <MyMiniModal
        isOpen={modalMustPortrait}
        onClose={() => { setModalMustPortrait(false) }}
        title={languageValues?.modalMustPortrait?.title[actLanguage]}
        subTitle={languageValues?.modalMustPortrait?.text[actLanguage]}
        topIcon={cropRotateIcon}
      >
        <Box sx={{
          display:"flex",
          justifyContent:"center",
        }}>
          <Button
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            onClick={() => { setModalMustPortrait(false) }}
          >
            {languageValues?.close[actLanguage]}
          </Button>
        </Box>
      </MyMiniModal>
      {/* END MODAL MUST PORTRAIT */ }

      {/* MODAL MUST LANDSCAPE */ }
      <MyMiniModal
        isOpen={modalMustLandscape}
        onClose={() => { setModalMustLandscape(false) }}
        title={languageValues?.modalMustLandscape?.title[actLanguage]}
        subTitle={languageValues?.modalMustLandscape?.text[actLanguage]}
        topIcon={cropRotateIcon}
      >
        <Box sx={{
          display:"flex",
          justifyContent:"center",
        }}>
          <Button
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            onClick={() => { setModalMustLandscape(false) }}
          >
            {languageValues?.close[actLanguage]}
          </Button>
        </Box>
      </MyMiniModal>
      {/* END MODAL MUST LANDSCAPE */ }
    </>
  )
};

export default Formation;
